import '../../Ui.css'

const Tag = (props) => {
    return (
        <div className={`ui-tag ${props.className}`} style={props.style}>{props.children}</div>
    )
}

export default Tag;